// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"c136fa46","421":"e19a57ea"}[chunkId] + ".chunk.js";
};